import React, { useState } from "react";
import { NavigationSection } from '../types/NavigationSection';
import resume from '../assets/GeneralCV2.pdf';

const NavBar: React.FC = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return(
        <div>
        { /* Mobile Design below */ }
            <div className="absolute top-4 right-4 z-50 lg:hidden">
                <button 
                    onClick={() => setMenuOpen(!menuOpen)}
                    className="rounded-xl border border-white/10 bg-black/80 px-1 py-2 text-sm shadow-md backdrop-blur"
                >
                    { menuOpen ? "✕" : "☰" }
                </button>

                { menuOpen && (
                    <div className="absolute right-0 mt-3 w-56 rounded-2xl border border-white/10 bg-black/90 p-3 shadow-xl backdrop-blur">
                        <nav className="flex flex-col gap-2">
                            <a
                                href={`${NavigationSection.ABOUT}`}
                                onClick={() => setMenuOpen(false)}
                                className="rounded-lg px-3 py-2 transition hover:bg-white/10"
                            >
                                About me
                            </a>

                            <a
                                href={`${NavigationSection.SKILLS}`}
                                onClick={() => setMenuOpen(false)}
                                className="rounded-lg px-3 py-2 transition hover:bg-white/10"
                            >
                                My Skills
                            </a>

                            <a
                                href={`${NavigationSection.EXP}`}
                                onClick={() => setMenuOpen(false)}
                                className="rounded-lg px-3 py-2 transition hover:bg-white/10"
                            >
                                My Experience
                            </a>

                            <a
                                href={resume}
                                onClick={() => setMenuOpen(false)}
                                className="rounded-lg px-3 py-2 transition hover:bg-white/10"
                            >
                                Preview Resume
                            </a>
                        </nav>
                    </div>
                )}
            </div>
        { /* Desktop Design below */ }
            <div className="absolute top-6 right-8 z-50 hidden lg:flex gap-8 text-white font-extrabold">
                <section id="My Skills">
                            <a
                                href={`${NavigationSection.SKILLS}`}
                                className="rounded-lg px-3 py-2 transition hover:bg-green-600"
                            >
                                My Skills
                            </a>                    
                </section>
                <section id="My Experience">
                            <a
                                href={`${NavigationSection.EXP}`}
                                className="rounded-lg px-3 py-2 transition hover:bg-green-600"
                            >
                                My Experience
                            </a>   
                </section>
                <section id="Preview Resume 2.0">
                            <a
                                href={resume}
                                className="rounded-lg px-3 py-2 transition hover:bg-green-600"
                            >
                                Preview Resume
                            </a>   
                </section>
            </div>    
        </div>

    );
};
export default NavBar;